import { Link } from "react-router-dom";
import Logo from "./Logo";

const COLS = [
  ["Customers", [["Find a Service", "/services"], ["Categories", "/categories"], ["My Bookings", "/bookings"]]],
  ["Businesses", [["List Your Business", "/list-your-business"], ["Provider Dashboard", "/provider-dashboard"], ["Sign In", "/sign-in"]]],
];

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-4 max-w-sm text-sm text-slate-500">Discover. Compare. Book. Find trusted local services across Aotearoa New Zealand and book with ease.</p>
          <p className="mt-4 inline-block rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-800">
            MVP preview: businesses marked DEMO are fictional sample data.
          </p>
        </div>
        {COLS.map(([title, links]) => (
          <div key={title}>
            <p className="text-sm font-semibold text-slate-900">{title}</p>
            <ul className="mt-4 space-y-3">
              {links.map(([label, to]) => (
                <li key={to}><Link to={to} className="text-sm text-slate-500 hover:text-sky-700">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-slate-100 py-6 text-center text-xs text-slate-400">© {new Date().getFullYear()} Bookvera. Prices shown in NZD.</div>
    </footer>
  );
}
